import { useState, useCallback, useMemo } from 'react'
import { clientsApi, usersApi } from '../services/api'

export function useClientSuccessMap() {
  const [clientCsMap, setClientCsMap] = useState<Map<string, string>>(new Map())
  const [emailToName, setEmailToName] = useState<Map<string, string>>(new Map())

  const load = useCallback(async () => {
    try {
      const [clients, users] = await Promise.all([
        clientsApi.list({ all: true }),
        usersApi.list(),
      ])

      const csMap = new Map<string, string>()
      clients.forEach((client) => {
        if (client.clientSuccess) {
          csMap.set(client.id, client.clientSuccess)
        }
      })
      setClientCsMap(csMap)

      const nameMap = new Map<string, string>()
      users.forEach((user) => {
        nameMap.set(user.email, user.name)
      })
      setEmailToName(nameMap)
    } catch (err) {
      console.error('Failed to load client success data:', err)
    }
  }, [])

  const getClientSuccessName = useCallback(
    (clientId: string): string | null => {
      const csEmail = clientCsMap.get(clientId)
      if (!csEmail) return null
      return emailToName.get(csEmail) || csEmail.split('@')[0]
    },
    [clientCsMap, emailToName]
  )

  return useMemo(() => ({ load, getClientSuccessName }), [load, getClientSuccessName])
}
